import { useEffect } from "react";
import { api, getToken } from "./api";

const HEARTBEAT_MS = 45_000;

async function sendHeartbeat(state) {
  try {
    if (!getToken()) return;
    await api("/presence/heartbeat", { method: "POST", body: { state } });
  } catch { /* best-effort */ }
}

/** Web presence: heartbeat while the tab is visible; "inactive" when hidden/closed. */
export function PresenceTracker({ userId }) {
  useEffect(() => {
    if (!userId) return undefined;
    let timer = null;
    const start = () => {
      sendHeartbeat("active");
      if (timer) clearInterval(timer);
      timer = setInterval(() => sendHeartbeat("active"), HEARTBEAT_MS);
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    if (document.visibilityState === "visible") start();
    const onVis = () => {
      if (document.visibilityState === "visible") start();
      else { stop(); sendHeartbeat("inactive"); }
    };
    document.addEventListener("visibilitychange", onVis);
    return () => { stop(); document.removeEventListener("visibilitychange", onVis); };
  }, [userId]);
  return null;
}

export function formatLastSeen(iso) {
  if (!iso) return "";
  try {
    const dt = new Date(iso);
    const diff = Date.now() - dt.getTime();
    if (diff < 0) return "just now";
    const s = Math.floor(diff / 1000);
    if (s < 60) return "just now";
    const m = Math.floor(s / 60);
    if (m < 60) return `${m} min ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h} hr ago`;
    const d = Math.floor(h / 24);
    if (d === 1) return "yesterday";
    if (d < 7) return `${d} days ago`;
    return dt.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
  } catch { return ""; }
}
